import React, { useEffect, useState } from 'react';
import { Alert, Badge, Button, Card, Col, Form, Pagination, Row, Spinner, Table } from '@themesberg/react-bootstrap';

export default function MyReports() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchMyReports = async () => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem('token') || '';
      const res = await fetch('/api/reports/my', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const json = await res.json();
      if (!res.ok || json.error) throw new Error(json.message || 'Failed to fetch reports');
      setItems(json.data || []);
    } catch (e) {
      setError(e?.message || 'Failed to fetch reports');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMyReports();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const statusBadge = (status) => {
    switch (status) {
      case 'pending':
        return <Badge bg="warning">Pending</Badge>;
      case 'reviewed':
        return <Badge bg="primary">Reviewed</Badge>;
      case 'action_taken':
        return <Badge bg="success">Action taken</Badge>;
      case 'rejected':
        return <Badge bg="danger">Rejected</Badge>;
      default:
        return <Badge bg="secondary">{status}</Badge>;
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 250 }}>
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (error) return <Alert variant="danger">{error}</Alert>;

  return (
    <Card className="shadow-sm border-0">
      <Card.Header>
        <Row className="align-items-center">
          <Col>
            <h5 className="mb-0">My Report History</h5>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body>
        <Table responsive hover>
          <thead>
            <tr>
              <th>Entity</th>
              <th>Reason</th>
              <th>Status</th>
              <th>Latest Admin Action</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            {items.map((r) => (
              <tr key={r.id}>
                <td>
                  {r.entity_type}: {r.entity?.name || r.entity?.email || r.entity_id || '-'}
                </td>
                <td>{r.reason || '-'}</td>
                <td>{statusBadge(r.status)}</td>
                <td>
                  {r.latest_admin_action ? (
                    <>
                      {r.latest_admin_action.action_type}
                      {r.latest_admin_action.admin ? ` (${r.latest_admin_action.admin.name || '-'})` : ''}
                    </>
                  ) : (
                    '-'
                  )}
                </td>
                <td>{r.created_at ? new Date(r.created_at).toLocaleString() : '-'}</td>
              </tr>
            ))}
            {items.length === 0 ? (
              <tr>
                <td colSpan={5} className="text-center text-muted">
                  No reports yet
                </td>
              </tr>
            ) : null}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}

